import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardBody
} from 'reactstrap';
import Select from 'react-select';
import ReactLoading from 'react-loading';
import logo from '../../assets/images/no-image.png';
import './ModalStyles.css';
import './ServiceRecordModal.css';

class VehicleDetailModal extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'unset';
  }

  componentWillUnmount() {
    document.body.classList.remove('modal-open');
    document.body.style.overflow = 'unset';
    document.body.style.paddingRight = '';
    
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());
  }

  handleModalClosed = () => {
    setTimeout(() => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '';
    }, 300);
  };

  render() {
    const {
      isOpen,
      toggle,
      formData,
      brands,
      models,
      selectedBrand,
      selectedModel,
      vehicleImages,
      vehicleLoading,
      userHasUpdatePermission,
      handleChange,
      handleBrandChange,
      handleModelChange,
      handleSubmit,
      handleVehicleImageClick,
      inspection,
      next_inspection,
      maintenance,
      next_maintenance
    } = this.props;
    const vehicleName = [selectedBrand?.label || formData.vehicleData.brand, selectedModel?.label || formData.vehicleData.model]
      .filter(Boolean)
      .join(' ') || 'Araç kaydı';
    const plate = (formData.vehicleData.plate || '-').toLocaleUpperCase('tr-TR');

    return (
      <Modal 
        isOpen={isOpen} 
        toggle={toggle} 
        size="xl"
        onClosed={this.handleModalClosed}
        className="modern-modal service-record-modal vehicle-record-modal"
        backdrop="static"
        fade={true}
        centered
      >
        <ModalHeader toggle={toggle} className="modal-header-gradient">
          <div className="modal-title-wrapper">
            <div className="modal-icon-wrapper">
              <i className="fa fa-car"></i>
            </div>
            <div>
              <span className="srm-eyebrow">ARAÇ KAYDI</span>
              <h5 className="mb-0">{plate}</h5>
              <small>Kimlik, teknik bilgiler ve görseller</small>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="modal-body-modern">
          <div className="srm-identity-card vehicle">
            <div className="srm-avatar"><i className="fa fa-car" /></div>
            <div className="srm-identity-copy">
              <small>PLAKA</small>
              <strong>{plate}</strong>
              <span>{vehicleName}</span>
            </div>
            <div className="srm-identity-meta">
              <span><i className="fa fa-calendar-o" /> {formData.vehicleData.year || 'Model yılı yok'}</span>
              <span><i className="fa fa-tachometer" /> {Number(formData.vehicleData.km || 0).toLocaleString('tr-TR')} km</span>
            </div>
          </div>
          <Form
            className="form"
            id="vehicleData"
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            <Row>
              <Col lg={6}>
                <Card className="info-card mb-3">
                  <CardBody>
                    <h6 className="section-title">
                      <i className="fa fa-id-card-o" /> Temel araç bilgileri
                    </h6>

                <FormGroup>
                  <Label for="plate" className="modern-label">
                    Plaka
                  </Label>
                  <Input
                    type="text"
                    name="vehicleData.plate"
                    id="plate"
                    placeholder="Plaka"
                    value={formData.vehicleData.plate}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="brand" className="modern-label">
                    Marka
                  </Label>
                  <Select
                    value={selectedBrand}
                    onChange={handleBrandChange}
                    options={brands}
                    placeholder="Marka Seçin"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: state.isFocused ? '#17a2b8' : '#ced4da',
                        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(23,162,184,.25)' : 'none',
                        '&:hover': { borderColor: '#17a2b8' }
                      })
                    }}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="model" className="modern-label">
                    Model
                  </Label>
                  <Select
                    value={selectedModel}
                    onChange={handleModelChange}
                    options={models}
                    placeholder="Model Seçin"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: state.isFocused ? '#17a2b8' : '#ced4da',
                        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(23,162,184,.25)' : 'none',
                        '&:hover': { borderColor: '#17a2b8' }
                      })
                    }}
                  />
                </FormGroup>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="year" className="modern-label">
                        Model yılı
                      </Label>
                      <Input
                        type="number"
                        name="vehicleData.year"
                        id="year"
                        placeholder="Model Yılı"
                        value={formData.vehicleData.year}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="gear_type" className="modern-label">
                        Vites Tipi
                      </Label>
                      <Input
                        type="select"
                        name="vehicleData.gear_type"
                        id="gear_type"
                        value={formData.vehicleData.gear_type}
                        onChange={handleChange}
                        className="modern-input"
                      >
                        <option value="">Vites Tipi Seçiniz</option>
                        <option value="otomatik">Otomatik</option>
                        <option value="manuel">Manuel</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup>
                  <Label for="package_name" className="modern-label">
                    Paket adı
                  </Label>
                  <Input
                    type="text"
                    name="vehicleData.package_name"
                    id="package_name"
                    placeholder="Paket Adı"
                    value={formData.vehicleData.package_name}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="maintenance_date" className="modern-label">
                        Bakım tarihi
                      </Label>
                      <Input
                        type="date"
                        name="vehicleData.maintenance_date"
                        id="maintenance_date"
                        value={maintenance}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="inspection_date" className="modern-label">
                        Muayene tarihi
                      </Label>
                      <Input
                        type="date"
                        name="vehicleData.inspection_date"
                        id="inspection_date"
                        value={inspection}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup>
                  <Label for="details" className="modern-label">
                    Araç detayları
                  </Label>
                  <Input
                    type="textarea"
                    name="vehicleData.details"
                    id="details"
                    placeholder="Araç detayları"
                    value={formData.vehicleData.details}
                    onChange={handleChange}
                    rows={3}
                    className="modern-input"
                  />
                </FormGroup>
                  </CardBody>
                </Card>
              </Col>

              <Col lg={6}>
                <Card className="info-card mb-3">
                  <CardBody>
                    <h6 className="section-title">
                      <i className="fa fa-cogs" /> Teknik bilgiler
                    </h6>

                    <FormGroup>
                      <Label for="gen" className="modern-label">
                        Nesil
                      </Label>
                  <Input
                    type="text"
                    name="vehicleData.gen"
                    id="gen"
                    placeholder="F30, Megane 4, Clio 3 vs..."
                    value={formData.vehicleData.gen}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="engine_no" className="modern-label">
                    Motor No
                  </Label>
                  <Input
                    type="number"
                    name="vehicleData.engine_no"
                    id="engine_no"
                    placeholder="Motor No"
                    value={formData.vehicleData.engine_no}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="engine_size" className="modern-label">
                    Motor hacmi
                  </Label>
                  <Input
                    type="text"
                    name="vehicleData.engine_size"
                    id="engine_size"
                    placeholder="Motor Hacmi"
                    value={formData.vehicleData.engine_size}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="km" className="modern-label">
                    Km
                  </Label>
                  <Input
                    type="number"
                    name="vehicleData.km"
                    id="km"
                    placeholder="Km"
                    value={formData.vehicleData.km}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="chassis_no" className="modern-label">
                    Şase No
                  </Label>
                  <Input
                    type="text"
                    name="vehicleData.chassis_no"
                    id="chassis_no"
                    placeholder="Şase No"
                    value={formData.vehicleData.chassis_no}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="key_no" className="modern-label">
                    Anahtar No
                  </Label>
                  <Input
                    type="text"
                    name="vehicleData.key_no"
                    id="key_no"
                    placeholder="Anahtar No"
                    value={formData.vehicleData.key_no}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="next_maintenance_date" className="modern-label">
                        Sonraki bakım tarihi
                      </Label>
                      <Input
                        type="date"
                        name="vehicleData.next_maintenance_date"
                        id="next_maintenance_date"
                        value={next_maintenance}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="next_inspection_date" className="modern-label">
                        Sonraki muayene tarihi
                      </Label>
                      <Input
                        type="date"
                        name="vehicleData.next_inspection_date"
                        id="next_inspection_date"
                        value={next_inspection}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* Araç Resimleri Card - Tam Genişlik */}
            <Row>
              <Col lg={12}>
                <Card className="info-card mb-3">
                  <CardBody>
                    <h6 className="section-title">
                      <i className="fa fa-picture-o" /> Araç görselleri
                    </h6>

                    {vehicleImages && vehicleImages.length > 0 && (
                      <FormGroup>
                        <Label className="modern-label">
                          Mevcut Resimler ({vehicleImages.length})
                        </Label>
                        <div className="vehicle-image-grid">
                          {vehicleImages.map((imageUrl, index) => (
                            <div
                              key={index}
                              className="vehicle-image-item"
                              onClick={() => handleVehicleImageClick(imageUrl)}
                            >
                              <img
                                src={imageUrl}
                                alt={`Vehicle ${index + 1}`}
                                onError={(e) => {
                                  e.target.src = logo;
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </FormGroup>
                    )}

                    <FormGroup>
                      <Label for="vehicleImages" className="modern-label">
                        Yeni Resim Yükle
                      </Label>
                      <Input
                        type="file"
                        name="vehicleData.vehicleImages"
                        id="vehicleImages"
                        multiple
                        onChange={handleChange}
                        className="modern-input"
                      />
                      <small className="form-text text-muted">
                        Birden fazla resim seçebilirsiniz (JPG, PNG)
                      </small>
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Form>
        </ModalBody>
        <ModalFooter className="modal-footer-modern">
          <Button 
            color="light" 
            onClick={toggle}
            className="modern-btn-secondary"
          >
            <i className="fa fa-times mr-2"></i>
            Kapat
          </Button>
          {vehicleLoading ? (
            <Button color="primary" disabled className="modern-btn btn-gradient-primary">
              <ReactLoading type="spin" width={'17px'} height={'17px'} color="#ffffff" className="d-inline-block mr-2" />
              Kaydediliyor...
            </Button>
          ) : (
            <Button color="primary" type="submit" form="vehicleData" disabled={!userHasUpdatePermission} className="modern-btn btn-gradient-primary">
              <i className="fa fa-save mr-2"></i>
              Değişiklikleri kaydet
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default VehicleDetailModal;
